import { Media } from "../../../types/media";
import { AboutNone } from "../AboutNone";
import {
  coordinationFormFields,
  crossOverFormFields,
  frontMediaFormFields,
  homeFormFields,
  MediaFormFieldTypes,
  MediaTypes,
  openingOfferFormFields,
  openTheWalletFormFields,
  perimeterBreakFormFields,
  productDominanceWallFormFields,
  roomSettingsFormFields,
  selectionPointFormFields,
  showcaseFormFields,
  statementMediaFormFields,
  vignetteFormFields,
  vitalityFormFields,
} from "../../../constants";
import { AboutCompareAndChoose } from "../AboutCompareAndChoose";
import { AboutRoom } from "../AboutRoom";
import { AboutMedia } from "../AboutMedia";

interface AboutSectionProps {
  media: Media;
  onSave: (newMedia: Media) => void;
}

const FormFieldConfiguration: Record<
  MediaTypes,
  {
    formFields?: MediaFormFieldTypes[];
    formFieldsValidation?: (field: MediaFormFieldTypes) => boolean;
  }
> = {
  [MediaTypes.COMPACT]: {},
  [MediaTypes.ALL_PARTS_STUDIO]: {},
  [MediaTypes.ROOM]: {},
  [MediaTypes.NONE]: {},
  [MediaTypes.ROOM_SETTINGS]: {
    formFields: roomSettingsFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.VIGNETTE]: {
    formFields: vignetteFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.COORDINATION_MEDIA]: {
    formFields: coordinationFormFields,
    formFieldsValidation: (field: MediaFormFieldTypes) =>
      field !== MediaFormFieldTypes.LONG_TERM_PRIORITY,
  },
  [MediaTypes.HOME]: {
    formFields: homeFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.VITALITY]: {
    formFields: vitalityFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.CROSS_OVER]: {
    formFields: crossOverFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.SHOW_CASE]: {
    formFields: showcaseFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.PERIMETER_BREAK]: {
    formFields: perimeterBreakFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.STATEMENT_MEDIA]: {
    formFields: statementMediaFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.PRODUCT_DOMINANCE_WALL]: {
    formFields: productDominanceWallFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.SELECTION_POINT]: {
    formFields: selectionPointFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.FRONT_MEDIA]: {
    formFields: frontMediaFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.OPEN_THE_WALLET]: {
    formFields: openTheWalletFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
  [MediaTypes.OPENING_OFFER]: {
    formFields: openingOfferFormFields,
    formFieldsValidation: (_field: MediaFormFieldTypes) => true,
  },
};

export const AboutSection = ({ media, onSave }: AboutSectionProps) => {
  const { formFields, formFieldsValidation } =
    FormFieldConfiguration[media.mediaType as MediaTypes] || {};
  return (
    <>
      {formFields && (
        <AboutMedia
          formFields={formFields}
          formFieldValidation={formFieldsValidation}
          media={media}
          onSave={(newMedia) => onSave(newMedia)}
        />
      )}
      {media.mediaType === MediaTypes.NONE && <AboutNone />}
      {(media.mediaType === MediaTypes.COMPACT ||
        media.mediaType === MediaTypes.ALL_PARTS_STUDIO) && (
        <AboutCompareAndChoose
          media={media}
          onSave={(newMedia) => onSave(newMedia)}
        />
      )}
      {media.mediaType === MediaTypes.ROOM && <AboutRoom media={media} />}
    </>
  );
};
